// extracted by mini-css-extract-plugin
export default {"color":"UiColor_color_EvHZB","selected":"UiColor_selected_s1ir8"};